import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const RouteMiddleWare = (props: any) => {
  const {
    component: Component,
    role,
    // match: { path },
    path,
  } = props;
  let pathname;
  // if (role === SUPER_ADMIN && path !== "/superadmin") {
  //   pathname = "/superadmin";
  // } else if (role === ADMIN && path !== "/admin") {
  //   pathname = "/admin";
  // } else if (role === USER && path !== "/employee") {
  //   pathname = "/employee";
  // }

  if (!props.onBoarding && !path.includes("/onboarding")) {
    return <Redirect to={{ pathname: "/onboarding" }} />;
  } else {
    return <Component {...props} />;
  }
};

function ProtectedRoute({ component, token, role, ...rest }: any) {
  return (
    <Route
      {...rest}
      render={(props) =>
        !!token ? (
          <RouteMiddleWare role={role} {...rest} {...props} component={component} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export default connect(({ auth: { token, onBoarding } }: any) => ({
  token,
  onBoarding,
}))(ProtectedRoute);
